import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown, Search } from "lucide-react";
import Sidebar from "../components/Sidebar";
import { fetchSocieta } from "../api";

const SchedePage = () => {
  const [q, setQ] = useState("");
  const [sector, setSector] = useState("Tutti");
  const [all, setAll] = useState([]);

  useEffect(() => {
    fetchSocieta()
      .then(setAll)
      .catch(() => setAll([]));
  }, []);

  const sectors = ["Tutti", ...Array.from(new Set(all.map((s) => s.sector)))];

  const filtered = all.filter((s) => {
    const matchQ =
      s.name.toLowerCase().includes(q.toLowerCase()) ||
      s.ticker.toLowerCase().includes(q.toLowerCase());
    const matchSector = sector === "Tutti" || s.sector === sector;
    return matchQ && matchSector;
  });

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 fade-in">
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-sq-orange">Home</Link>
        <span>/</span>
        <span className="text-sq-navy font-medium">Schede società quotate</span>
      </div>

      <h1 className="font-serif-display text-4xl text-sq-navy mb-2">Schede società quotate</h1>
      <p className="text-gray-600 mb-4 max-w-2xl">
        Anagrafica e quotazioni delle principali società quotate sui mercati italiani. Sistema scalabile
        per oltre 100 società.
      </p>
      <div className="w-16 h-1 bg-sq-orange mb-8" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <div className="flex flex-1 border border-sq rounded-sm overflow-hidden">
              <span className="px-3 flex items-center text-gray-400">
                <Search size={16} />
              </span>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Cerca società o ticker..."
                className="flex-1 px-2 py-2.5 text-sm outline-none"
              />
            </div>
            <div className="flex flex-wrap gap-2">
              {sectors.slice(0, 6).map((s) => (
                <button
                  key={s}
                  onClick={() => setSector(s)}
                  className={`px-3 py-2 text-xs rounded-sm border transition-colors ${
                    sector === s
                      ? "bg-sq-orange text-white border-sq-orange"
                      : "border-sq text-sq-navy hover:border-sq-orange"
                  }`}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <div className="border border-sq rounded-sm overflow-hidden">
            <div className="grid grid-cols-12 bg-sq-navy text-white text-xs uppercase tracking-wide px-4 py-3">
              <span className="col-span-5">Società</span>
              <span className="col-span-3">Settore</span>
              <span className="col-span-2 text-right">Prezzo</span>
              <span className="col-span-2 text-right">Var. %</span>
            </div>
            <div className="divide-y divide-[#e6e8ec]">
              {filtered.map((s) => (
                <div
                  key={s.id}
                  className="grid grid-cols-12 items-center px-4 py-3.5 hover:bg-sq-light transition-colors"
                >
                  <div className="col-span-5">
                    <div className="font-semibold text-sq-navy">{s.name}</div>
                    <div className="text-xs text-gray-400">{s.ticker} · {s.mercato}</div>
                  </div>
                  <span className="col-span-3 text-sm text-gray-600">{s.sector}</span>
                  <span className="col-span-2 text-right text-sm font-medium text-sq-navy">€ {s.price}</span>
                  <span
                    className={`col-span-2 text-right text-sm font-semibold flex items-center justify-end gap-1 ${
                      s.up ? "text-emerald-600" : "text-red-600"
                    }`}
                  >
                    {s.up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                    {s.change}%
                  </span>
                </div>
              ))}
              {filtered.length === 0 && (
                <div className="px-4 py-8 text-center text-gray-500 text-sm">Nessuna società trovata.</div>
              )}
            </div>
          </div>
        </div>
        <Sidebar />
      </div>
    </div>
  );
};

export default SchedePage;
